<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card rounded="xl" outlined>
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">Места в общежитиях</h6>
          </v-card-title>
        </v-card>
        <CardsHostelStatuses class="mt-3"/>
        <v-card rounded="xl" outlined class="my-6">
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">Места факультетов</h6>
          </v-card-title>
        </v-card>
        <CardsFacultyPlaces :dialog_vis="dialog_vis" @updateProp="updateProp"/>
        <DialogFacultyPlaces :department_id="department_id" :dialog_vis="dialog_vis" @updateProp="updateProp"/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
    import {mapActions, mapState, mapMutations, mapGetters} from "vuex";
    import _ from "lodash";
    import CardsHostelStatuses from "../DistributionPlacesCampus/CardsHostelStatuses";
    import CardsFacultyPlaces from "./CardsFacultyPlaces";
    import DialogFacultyPlaces from "./DialogFacultyPlaces";

    export default {
        name: "Distribution",
        components: {
            CardsHostelStatuses,
            CardsFacultyPlaces,
            DialogFacultyPlaces
        },
        data: () => ({
            dialog_vis: false,
            selection_places: [],
            vis_alert: false,
            department_id: 0
        }),
        mounted() {
            // this.GetDormFac();
            this.GetStatusCampusPlaces();
            this.GetStatusFacultiesPlaces();
            // this.GetStructHostel().then(() => {
            //     this.placesHostels(this.hostels)
            // })
        },
        computed: {
            ...mapState({
                // hostels: state => state.placesInDormitories.hostels,
                // selected_dorm_faculty: state => state.placesInDormitories.selected_dorm_faculty,
                // distribution: state => state.placesInDormitories.distribution,
                // set_error: state => state.placesInDormitories.set_error,
                // current_hostels: state => state.placesInDormitories.current_hostels,
                // selected_place: state => state.placesInDormitories.selected_place,
            }),
            ...mapGetters({
                // placeSections: 'placesInDormitories/placeSections',
            }),
        },
        methods: {
            ...mapActions({
                // GetStructHostel: 'placesInDormitories/GetStructHostel',
                // CreateDormFac: 'placesInDormitories/CreateDormFac',
                // GetDormFac: 'placesInDormitories/GetDormFac',
                GetStatusCampusPlaces: 'placesInDormitories/GetStatusCampusPlaces',
                GetStatusFacultiesPlaces: 'placesInDormitories/GetStatusFacultiesPlaces',
            }),
            ...mapMutations({
                // placesHostels: 'placesInDormitories/placesHostels',
                // setDormitory: 'placesInDormitories/setDormitory',
                // setSection: 'placesInDormitories/setSection',
                // setRoom: 'placesInDormitories/setRoom',
            }),
            updateProp(prop){
                this.dialog_vis = prop.dialog_vis
                this.department_id = prop.department_id
            },
        },
    }
</script>

<style scoped>

</style>